import React from 'react';
import { Field, Input, Label } from '@headlessui/react';

interface CheckboxOption {
  value: string;
  label: string;
}

interface FormCheckboxGroupProps {
  name: string;
  label: string;
  options: CheckboxOption[];
  values: string[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string | string[];
  touched?: boolean;
  required?: boolean;
  icon?: React.ReactNode;
  className?: string;
}

const FormCheckboxGroup: React.FC<FormCheckboxGroupProps> = ({
  name,
  label,
  options,
  values,
  onChange,
  onBlur,
  error,
  touched,
  required = false,
  icon,
  className,
}) => {
  return (
    <div className={className}>
      <p className="text-base font-semibold text-slate-700 mb-4 flex items-center gap-2">
        {icon && icon}
        {label} {required && <span className="text-red-500">*</span>}
      </p>

      <div className="space-y-3 bg-white rounded-lg p-4 border border-slate-200">
        {options.map((option) => (
          <Field key={option.value} className="flex items-center">
            <Input
              type="checkbox"
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              checked={values.includes(option.value)}
              value={option.value}
              className="w-5 h-5 text-blue-600 bg-white border-slate-300 rounded focus:ring-2 focus:ring-blue-500 transition duration-150 ease-in-out cursor-pointer"
            />
            <Label className="text-base font-medium text-slate-700 ml-3 cursor-pointer">
              {option.label}
            </Label>
          </Field>
        ))}

        {touched && error ? (
          <div className="text-red-700 text-sm mt-2 bg-red-50 border border-red-200 p-2 rounded">
            {Array.isArray(error) ? error.join(', ') : error}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default FormCheckboxGroup;
